import React from "react";

const MasjidAlHussain = () => {
  // Additional images for the mosque
  const additionalImages = [
    "/images/Picture32.jpg",
    "/images/Picture76.jpg",
    "/images/Picture77.jpg",
    "/images/Picture78.jpg",
    "/images/Picture50.jpg",
  ];

  return (
    <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
      {/* Top Section: Text and Main Image */}
      <div className="flex flex-col lg:flex-row items-start gap-8">
        {/* Left Text Section */}
        <div className="lg:w-2/3 space-y-6">
          <h2 className="text-3xl font-bold text-gray-800">
            Masjid Al Hussain, Bahria Town, Lahore
          </h2>
          <h3 className="text-2xl font-bold text-gray-800 leading-tight">
            Construction Services by PACIFIC BUILDERS (PVT) LTD
          </h3>
          <p className="text-gray-700">
            Below is a summary of the ongoing project for{" "}
            <strong>Masjid Al Hussain</strong>, located in Hussain Block, Bahria Town, Lahore.{" "}
            <strong>PACIFIC BUILDERS (PVT) LTD</strong> is providing reliable structural works for this project.
          </p>

          <div className="text-lg text-gray-700">
            <p><strong>Scope of Work:</strong> Grey Structural works</p>
            <p><strong>Architect:</strong> Design wing, Bahria Town</p>
            <p><strong>Location:</strong> Hussain Block, Bahria Town, Lahore, Pakistan</p>
            <p><strong>Client:</strong> Bahria Town (PVT) LTD</p>
            <p><strong>Status:</strong> Ongoing</p>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="lg:w-1/3">
          <img
            src="/images/Picture75.jpg"
            alt="Masjid Al Hussain Construction"
            className="w-full h-auto rounded shadow"
          />
        </div>
      </div>

      {/* Additional Images Section */}
      {additionalImages.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {additionalImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Masjid Al Hussain ${index + 1}`}
              className="w-full h-[200px] rounded shadow"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MasjidAlHussain;
